import React from "react";

function OverlayText(props) {
  const overlayTextStyle = {
    position: "absolute",
    top: "50%",
    left: "55%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "white",
    fontSize: "100px",
    fontFamily: "Brownhill Script, sans-serif",
  };
  const combinedStyles = { ...overlayTextStyle, ...props.styles };
  return <div style={combinedStyles}>{props.text}</div>;
}
export default OverlayText;
